<template>
    <div :class="['hpHeroText', 'reveal']" style="width:100%;">      
      <div class="heroContent">
          <div class="heroText">
              <div class="hero-title sptx">
                  <splitter :content="localize(sectionData.title)" startDelay='0.1' >
                  </splitter>
              </div>  
              <div class="hero-desc sptx pt-l">
                <splitter :content="localize(sectionData.desc)" startDelay="0.4" >
                </splitter>
              </div>

              <!-- <i class="fal fa-computer-mouse-scrollwheel"></i> -->
              <!--
              <div :class="['heroBtnWrapper', showBtn ? 'showBtn' : '']">
                  <a class="roundBtn" @click="scrollToNextSection" >
                      <span class="title">{{localize('@explore')}}</span>
                      <i class="fal fa-chevron-down pl-s" ></i>
                  </a>
              </div>
              -->

          </div>
      </div>
    </div>
</template>

<style>
    .heroContent
    {
      height: 50vh; 
      display: grid;
      align-items: center;
      position: initial;
      padding-left: 0px; 
      background-color: #fcfcfc;
      width: 100vw;
    }
    .heroText
    {
      width: 50vw;
      color: #202020;
      padding: 0px 0px;
      margin: auto;
    }

    .heroContent_v1
    {
      background-color: rgba(255,255,255,0.5);
      min-width: 100%;
      min-height: 100%;
      display: grid;
      align-items: center;
      z-index: 10;
      position: absolute;
      padding-left: max(180px, 10vw); 
    }
    .heroText_v1
    {
      width: 45vw;
      color: #202020;
    }

    .heroContent_old
    {
      min-width: 100%;
      min-height: 100%;
      display: grid;
      align-items: center;
      z-index: 10;
      position: absolute;
      /* padding-left: max(180px, 10vw);  */
      padding-left: 0px; 
    }






    .hero-title,
    .hero-title .sptx{        
        color: var(--text-blue);
        font-size: 18px !important;
        font-weight: 100 !important;
        font-weight: 400 !important;        
        letter-spacing: -0.5px;
    }    

    .hero-desc
    { 
        overflow-wrap:break-word;
        font-size: 28px !important;
        letter-spacing: -1px !important;
        font-weight: 100 !important;
        color: #202020;
        line-height: 36px  !important;
    }    
    .heroVideoConatiner
    {
      opacity: 0;
      transition: all ease-in 0.5s;
    }
    .heroVideoConatiner.active {
      opacity: 1;
    }
    .hpHeroText .heroBtnWrapper
    {
      clear: both;margin-top: 35px;
      transition: all ease-out 0.6s;
      transition-delay: 1.2s;
      transform: translateY(10px);
      opacity: 0;
    }
/*     .hpHeroText .heroBtnWrapper.showBtn
    {
      transform: translateY(0px);
      opacity: 1;
    }
 */ 

    .hpHeroText.reveal.active .heroBtnWrapper
    {
      transform: translateY(0px);
      opacity: 1;

    }

    .roundBtn
    {
      cursor: pointer;
      position: relative;
      display: -webkit-inline-box;
      display: -ms-inline-flexbox;
      display: inline-flex;
      -webkit-box-orient: horizontal;
      -webkit-box-direction: normal;
      -ms-flex-direction: row;
      flex-direction: row;
      -ms-flex-wrap: nowrap;
      flex-wrap: nowrap;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: start;
      -ms-flex-pack: start;
      justify-content: flex-start;
      text-align: left;    
      padding: 25px 25px;
      border-radius: 40px;
      height: 40px;
      font-size: 16px; 
      color: #1178be;
      border: 1px solid #1178be;
      background-color:transparent;

    }
    .roundBtn span
    {
      line-height: 1;
      display: inline-block;
      vertical-align: middle;    
      font-family: Arial, Helvetica, sans-serif;
      font-weight: normal;
    }

  @media (hover:hover) {
    .roundBtn:hover
    {
      background-color: #1178be;
      color: #fff;
      border: 1px solid #1178be ;
    }    
  }


    @media (max-width: 850px) { 
      .hpHeroText
      {
        min-height: 30vh;
      }
      .hpHeroText .heroBtnWrapper
      {
        margin-top: 25px;
      }
      .roundBtn
      {
        padding: 14px 18px;
        height: 40px;
        font-size: 14px; 
        color: #1178be;
      }      


        .heroContent
        {
            height: auto; 
            display: grid;
            align-items: center;
            position: initial;
            padding-left: 0px; 
            background-color: #fcfcfc;
            width: 100vw;
        }
        .heroText
        {
            width: 80vw;
            color: #202020;
            padding: 50px 0px;
            margin: auto;
        }


      .hero-title,
      .hero-title .sptx{        
          font-size: 20px !important;
          font-weight: 400 !important;
      }    

      .heroContent{
        padding-left: 0px;
        display: block;
        position:initial;
        top:0px;
      }      
      .hero-desc,
      .hero-desc .sptx{
          font-size: 20px !important;
          letter-spacing: 0px !important;
          line-height: 24px  !important;
          font-weight: 300 !important;
      }        


    }

    @media (max-width: 400px) { 

    }

    /* Portrait iPad mini 1, iPad 1 and iPad 2*/
    @media only screen 
    and (min-device-width: 768px) 
    and (max-device-width: 1024px) 
    and (-webkit-min-device-pixel-ratio: 1) 
    and (orientation: portrait)
    {
        .hpHeroText
        {
          min-height: initial;
        }
    }    
</style>


<script>
import { mapActions, mapState } from "vuex";
import { splitLines,isMobileScreen }         from "@/utils";
import splitter from "@/views/com/splitter.vue";

export default 
{
  name: "hpHeroText",
  components:{splitter},
  data(){
      return {
          isMobileLayout:false,
          showVideo:false,
          showBtn:false
      }
  },
  mounted() 
  {
    var vm = this;    
    vm.startAnimation();
    vm.isMobileLayout = isMobileScreen();

    //alert("vm.isMobileLayout="+vm.isMobileLayout);

    setTimeout(() => {
      vm.showBtn=true;//start the video after 2 sec
    }, 200);

    //setTimeout(() => {
      //vm.showVideo=true;//start the video after 2 sec
    //}, 2000);
  },
  methods: {
    scrollToNextSection()
    {
        document.getElementsByClassName("siteSection")[2].scrollIntoView({ 
          behavior: 'smooth' 
        });
    },
    startAnimation()
    {
        var vm = this;
    }
  },
  computed: {
    ...mapState(["siteData"]),
      sectionData(){
          return this.siteData.SECTIONS[0];
      }
    //...mapState(["pageLayoutData", "locale", "dirtyHome"]),
  }
};
</script>

